import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=5a01e615&scoped=true"
import script from "./BlockForm.vue?vue&type=script&lang=js"
export * from "./BlockForm.vue?vue&type=script&lang=js"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=5a01e615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01e615",
  null
  
)

export default component.exports